export default (offsetHeight = 465) => ({
  data: () => ({
    tableHeight: 0
  }),

  props: {
    defaultTableHeight: {
      type: [Number, Function],
      default: () => () => window.innerHeight
    }
  },

  mounted() {
    this.onResize()
    window.addEventListener('resize', this.onResize)
  },

  methods: {
    onResize() {
      const windowHeight = isNaN(this.defaultTableHeight)
        ? this.defaultTableHeight()
        : this.defaultTableHeight
      this.tableHeight = windowHeight - offsetHeight
    }
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)
  }
})
